// extracted by mini-css-extract-plugin
export default {"grid":"ebc758"};